import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import MenuMain from 'components/components/common/layouts/MenuMain';
import flag_no from 'components/assets/img/flag/no.svg';
import flag_uk from 'components/assets/img/flag/uk.svg';
import flag_pl from 'components/assets/img/flag/pl.svg';
import flag_ru from 'components/assets/img/flag/ru.svg';
import visa from 'components/assets/img/logo/mono/gray/visa.svg';
import mastercard from 'components/assets/img/logo/mono/gray/mastercard.svg';
import americanExpress from 'components/assets/img/logo/mono/gray/american-express.png';
import { withStyles } from '@material-ui/core/styles';
import Radio from '@material-ui/core/Radio'
import styles from '../customStylesRadioButton';
import T from 'components/common/translations/Translate';
import LocalStorageHelper from 'components/common/helpers/LocalStorageHelper';
import { setTranslation } from 'components/actions'
import AppLink from 'components/common/AppLink';
import TransHelper from 'components/common/translations/TransHelper';
import withRouter from 'components/components/common/withRouter';
import Header from 'components/components/common/layouts/Header';
import classNames from 'classnames';
import originAxios from 'axios';

class LandingLayout extends Component {

  handleChange = (lang, e) => {
    e.preventDefault();
    var value = lang;
    originAxios.post('/save-locale', { locale: value });

    TransHelper.translateCurrentUrl(
      value,
      this.props.locale,
      this.props.history,
      this.props.location
    );
    this.props.setTranslation(value);
    LocalStorageHelper.setLocale(value);
  };

  logoutUser = (event) => {
    LocalStorageHelper.removeToken();
    this.props.setUserLogout();
    this.props.history.push('/' + this.props.locale);
  }

  componentDidMount() {
    document.body.removeAttribute('class');
    document.body.classList.remove('overflow-hidden');
    //add year in copyright
    if (!this.props.isLogged) {
      var date = new Date();
      var yyyy = date.getFullYear();
      document.getElementById('year').innerHTML = yyyy;
    }
  }

  scrollToTop = (scrollDuration) => {
    const scrollHeight = window.scrollY,
      scrollStep = Math.PI / (scrollDuration / 15),
      cosParameter = scrollHeight / 2;
    var scrollCount = 0,
      scrollMargin,
      scrollInterval = setInterval(function () {
        if (window.scrollY != 0) {
          scrollCount = scrollCount + 1;
          scrollMargin = cosParameter - cosParameter * Math.cos(scrollCount * scrollStep);
          window.scrollTo(0, (scrollHeight - scrollMargin));
        }
        else clearInterval(scrollInterval);
      }, 15);
  }

  skipToBooking = (e) => {
    if (TransHelper.findRouteKey(this.props.locale, location.pathname) === "home") {
      e.preventDefault();
      this.scrollToTop(500);
    }
  }

  render() {
    const { locale, isLogged } = this.props;
    var showSections = !isLogged;
    return (
      <Fragment>
        <Header />
        <div className={
          classNames({
            'content-wrap-logged': isLogged,
            'content-text-wrap': !isLogged
          })
        }>
          {this.props.children}

          {showSections && <Fragment>
            <section className="skip-booking">
              <div className="skip-booking__content">
                <div className="headline">
                  <h2><T>content.layout.landingLayout.title</T></h2>
                  <p>
                    <T>content.layout.landingLayout.desc</T>
                  </p>
                </div>
                <Link to="/" className="button" onClick={this.skipToBooking}><T>content.layout.landingLayout.bookNow</T></Link>
              </div>
            </section>

            <section className="questions">
              <div className="row">
                <div>
                  <h2><T>content.layout.landingLayout.questionsTitle</T></h2>
                </div>

                <div>
                  <p><a href="mailto:support@flyo.no">support@flyo.no</a></p>
                </div>
              </div>
            </section>

            <footer className="footer">
              <div className="footer__info">
                <div className="row">
                  <div>
                    <address itemScope itemType="http://schema.org/Organization">
                      <div itemProp="name">Flyo</div>
                      <div itemProp="streetAddress">Verkseier Furulunds vei 22</div>
                      <div><span itemProp="postalCode">0668</span> <span itemProp="addressLocality">Oslo, Norge</span></div>
                    </address>

                    <ul className="list-hor">
                      <li className="list-hor__item">
                        <a href="https://www.facebook.com/Pks.oslo/" target="_blank">
                          <FontAwesomeIcon
                            icon={['fab', 'facebook-f']}
                          />
                        </a>
                      </li>

                      <li className="list-hor__item">
                        <a href="">
                          <FontAwesomeIcon
                            icon={['fab', 'google']}
                          />
                        </a>
                      </li>
                    </ul>
                  </div>

                  <div className="footer__cards">
                    <ul>
                      <li>
                        <img src={visa} alt="visa" />
                      </li>

                      <li>
                        <img src={mastercard} alt="mastercard" />
                      </li>

                      <li>
                        <img src={americanExpress} alt="american express" />
                      </li>
                    </ul>
                    <p><T>content.layout.landingLayout.poweredByStripe</T></p>
                  </div>
                </div>
              </div>

              <div className="footer__sitemap">
                <div className="row">
                  <div className="footer__menu">
                    <div>
                      <MenuMain locale={this.props.locale} isFooter />
                    </div>

                    <div>
                      <ul>
                        <li>
                          <AppLink to="routes.url.login"><T>content.common.logIn</T></AppLink>
                        </li>
                        <li>
                          <AppLink to="routes.url.signup"><T>content.common.signUp</T></AppLink>
                        </li>
                      </ul>

                      <ul className="menu-terms">
                        <li>
                          <AppLink to="routes.url.termsAndConditions"><T>content.common.terms</T></AppLink>
                        </li>
                        <li>
                          <AppLink to="routes.url.privacyPolicy"><T>content.common.privacyPolicy</T></AppLink>
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div className="footer__lang">
                    <ul className="list-lang">
                      <li className="list-lang__item">
                        <Link to="/no" onClick={(e) => this.handleChange('no', e)}>
                          <img src={flag_no} alt="Norwey" />
                          Norsk
                          <Radio
                            value="no"
                            checked={locale === 'no'}
                            onChange={(e) => this.handleChange('no', e)}
                            classes={{
                              root: this.props.classes.root,
                              checked: this.props.classes.checked,
                            }}
                            className="radio-button"
                            name="language"
                            id="norsk"
                          />
                        </Link>
                      </li>

                      <li className="list-lang__item">
                        <Link to="/" onClick={(e) => this.handleChange('en', e)}>
                          <img src={flag_uk} alt="English" />
                          English
                          <Radio
                            value="en"
                            checked={locale === 'en'}
                            onChange={(e) => this.handleChange('en', e)}
                            classes={{
                              root: this.props.classes.root,
                              checked: this.props.classes.checked,
                            }}
                            className="radio-button"
                            name="language"
                            id="english"
                          />
                        </Link>
                      </li>

                      <li className="list-lang__item">
                        <Link to="/pl" onClick={(e) => this.handleChange('pl', e)}>
                          <img src={flag_pl} alt="Polish" />
                          Polski
                          <Radio
                            value="pl"
                            checked={locale === 'pl'}
                            onChange={(e) => this.handleChange('pl', e)}
                            classes={{
                              root: this.props.classes.root,
                              checked: this.props.classes.checked,
                            }}
                            className="radio-button"
                            name="language"
                            id="polish"
                          />
                        </Link>
                      </li>

                      {/* <li className="list-lang__item">
                        <Link to="/ru" onClick={(e) => this.handleChange('ru', e)}>
                          <img src={flag_ru} alt="Russian" />
                          Russian
                          <Radio
                            value="ru"
                            checked={locale === 'ru'}
                            onChange={(e) => this.handleChange('ru', e)}
                            classes={{
                              root: this.props.classes.root,
                              checked: this.props.classes.checked,
                            }}
                            className="radio-button"
                            name="language"
                            id="russian"
                          />
                        </Link>
                      </li> */}
                    </ul>
                  </div>
                </div>
              </div>

              <div className="footer__copy">
                <div className="row">
                  <p>© <span id="year">2018</span> <AppLink to="routes.url.home">Flyo AS</AppLink>. All rights reserved</p>
                </div>
              </div>
            </footer>
          </Fragment>}
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    locale: state.app.locale,
    isLogged: state.app.isLogged
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    { setTranslation }
  )(withStyles(styles)(LandingLayout)));
